export const OE_SERVICE = "/open-enrollment-sb/v0";
export const OE_ACTION_CONTROLS = `${OE_SERVICE}/action_controller`;
export const OE_ALL_ACTION_CONTROLS = `${OE_ACTION_CONTROLS}/index.json`; // ?schoolYearKey={integer}&differentiator={integer}
export const OE_DISTRICT_WINDOW = `${OE_SERVICE}/district_window`;
export const OE_DISTRICT_WINDOWS_BY_SCHOOLYEAR = `${OE_DISTRICT_WINDOW}/school_year_key`; // /{schoolYearKey}/index.json
export const OE_PARTICIPATING_SCHOOL = `${OE_SERVICE}/participating_school`; // /{id}/detail.json?fetchLocationData=true
export const OE_SCHOOL_YEAR_KEY = `${OE_DISTRICT_WINDOW}/active_school_year_key/detail.json`;
export const OE_STUDENT = `${OE_SERVICE}/student`;
export const OE_STUDENT_SEARCH = `${OE_STUDENT}`; // /{schoolyearKey}/index.json?studentNumber=<studentNumber>
export const OE_STUDENT_DETAILS = `${OE_STUDENT}/details`; // /{id}/detail.json
